export const isRecommendedBracketSize = (size: number): boolean => {
  return Math.log2(size) % 1 === 0
}

export const getClosestPerfectBracketSize = (size: number): number => {
  const result = Math.pow(2, Math.round(Math.log2(size)))
  if (result < 2) return 2
  return result
}

export const getBracketSizeMessage = (size: number): string | undefined => {
  if (isRecommendedBracketSize(size)) return
  return `First-round byes will be created automatically to balance the bracket.`
}

export const getBracketNumberOfRounds = (numPlayers: number): number => {
  return Math.ceil(Math.log2(Math.max(2, numPlayers)))
}
